<template>
  <log-entry :log-entry="logEntry" :resource-type="resourceType">
    <media-changed-properties
      :meta="meta"
      :properties="logEntry.properties"
      :relations="logEntry.relations"
      :resource-type="resourceType"
    ></media-changed-properties>
  </log-entry>
</template>
<script>
import LogEntry from '@kanrisha/components/AppEventLog/LogEntry';
import MediaChangedProperties from '@kanrisha/components/Elements/EventLog/MediaChangedProperties';

export default {
  components: {
    MediaChangedProperties,
    LogEntry,
  },
  props: {
    logEntry: {
      type: Object,
      default: () => {},
    },
    resourceType: { type: String, default: () => '' },
    meta: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    return {};
  },
};
</script>
